/**
 * Standard product GraphQL query
 */
export const productQuery = `
    id
    title
    handle
    tags
    availableForSale
    productType
    vendor
    images(first: 10) {
        edges {
            node {
                url
            }
        }
    }
    priceRange {
        maxVariantPrice {
            amount
        }
        minVariantPrice {
            amount
        }
    }
    variants(first: 1) {
        edges {
            node {
                id
                availableForSale
                compareAtPrice {
                    amount
                }                                
            }
        }
    }
`;

/**
 * The products loaded from graphQL need to be edited to
 * - name variables to match liquid versions
 * - set URL correctly
 * - fix IDs with atob()
 * - set pricing correctly
 */
export function transformGraphqlProduct(productNode, collectionHandle=null) {
    return {
        objectType: "product",
        handle: productNode.handle,
        url: !!collectionHandle ? `/collections/${collectionHandle}/products/${productNode.handle}` : `/products/${productNode.handle}`,
        id: parseInt(productNode.id.replace('gid://shopify/Product/', '')),
        tags: productNode.tags.map(tag => tag.toLowerCase()),
        type: productNode.productType,
        vendor: productNode.vendor,
        title: productNode.title,
        available: productNode.availableForSale,
        price: productNode.priceRange.minVariantPrice.amount * 100,
        min_price: productNode.priceRange.minVariantPrice.amount * 100,
        max_price: productNode.priceRange.maxVariantPrice.amount * 100,
        compare_at_price: productNode.variants.edges[0].node.compareAtPrice ? productNode.variants.edges[0].node.compareAtPrice.amount * 100 : null,
        images: productNode.images.edges.map(image => image.node.url)
    }
}

/**
 * The products loaded from Shopify Product Ajax API need to be edited to
 * - conform to Liquid Project object
 */
export function transformAjaxProduct(product) {
    product.options_with_values = product.options;
    product.options = product.options.map(option => option.name);
    return product;
}

export function transformSearchspringProduct(product) {
    return {
        ...product,
        available: product.ss_available === "1",
        id: product.uid,
        images: product.imageUrl ? [product.imageUrl] : [],
        price: product.price * 100,
        title: product.name,
        vendor: product.brand,
        compare_at_price: product.variant_compare_at_price * 100,
        variants_min_price: product.ss_price_range?.length ? Math.min(...product.ss_price_range) * 100 : null,
        variants_max_price: product.ss_price_range?.length ? Math.max(...product.ss_price_range) * 100 : null,
    }
}